import clsx from 'clsx';
import { useEffect, useState, useMemo, createContext, useContext, useRef, useCallback } from 'react';
import { useDispatch, useSelector, Provider } from 'react-redux';
import { C as CookieCategories, a as CONSENT_MANAGER_INITIAL_SLICE_STATE, p as parseCookieValues, f as fullSelection, i as initSelection } from './parseCookieValues-9a061b22.js';
export { a as CONSENT_MANAGER_INITIAL_SLICE_STATE, b as COOKIE_CATEGORIES, C as CookieCategories } from './parseCookieValues-9a061b22.js';
import classnames from 'classnames';
import { FocusTrap } from 'focus-trap-react';
import { createSlice, createSelector, createListenerMiddleware, configureStore } from '@reduxjs/toolkit';
import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { Icon, Typography, Checkbox, Link, Button } from '@platform/elements';
import { closeLight } from '@platform/icons';
import { Subject, distinctUntilChanged, BehaviorSubject, map } from 'rxjs';
import { useForm, FormProvider, useFormContext, Controller } from 'react-hook-form';
import { useIsomorphicLayoutEffect } from 'react-use';

var styles$9 = {"Modal":"Modal_7Nwr-rHslw","ModalWithTopMargin":"ModalWithTopMargin_Ew52kpfY4G","ModalContent":"ModalContent_-l86x969oi","ScrollView":"ScrollView_gY-faNTOci"};

const MODAL_CONTAINER_CLASS_NAME = '__SSR_CONSENT_MANAGER__';

const Content = {
  header: {
    headline: 'Hier ist alles auf Sie abgestimmt',
    settings: 'Cookie-Einstellungen'
  },
  introduction: {
    paragraph_1: 'Wir verwenden Cookies zu Funktions-, Performance- und Komfortzwecken sowie zur Darstellung personalisierter Inhalte und Anzeigen, um Ihnen ein optimales Nutzererlebnis zu bieten und den Betrieb unserer Website sicherzustellen. Unter "Cookie Einstellungen" können Sie selbst entscheiden, welche Cookie-Kategorien Sie zulassen sowie Ihre Einstellungen jederzeit ändern oder Ihre Zustimmung widerrufen. Ihre Zustimmung schließt den Einsatz von Drittanbietern oder externen Unternehmen ein, die ihren Sitz in einem Land außerhalb der Europäischen Union, wie z.B. in der USA haben. In diesen Ländern kann trotz sorgfältiger Auswahl und Verpflichtung der Dienstleister ggf. kein angemessenes Datenschutzniveau garantiert werden. Sofern eine Datenübermittlung in die USA stattfindet, besteht ggf. das Risiko, dass diese Daten von US-Behörden zu Kontroll- und Überwachungszwecken verarbeitet werden können, ohne dass wirksame Rechtsbehelfe vorhanden oder sämtliche Betroffenenrechte durchsetzbar sind. Mehr Informationen erhalten Sie in unserer',
    privacy_link: 'Datenschutzerklärung',
    legal: 'Eine detaillierte Auflistung der von uns auf der Website genutzten Cookie-Anbieter und die entsprechenden Opt-Out Links sowie Hinweise zum Datenschutz der Anbieter erhalten Sie hier unter',
    legal_link: '"B. 2. Welche Arten von Cookies verwenden wir?"'
  },
  settings: [{
    id: CookieCategories.NECESSARY,
    headline: 'Erforderliche Cookies',
    checkbox: 'Erforderliche Cookies',
    paragraphs: ['Erforderliche Cookies umfassen sowohl technische notwendige als auch funktionale Cookies. Technisch notwendige Cookies sind notwendig, damit Sie sich auf der Website bewegen und ihre Funktionen umfassend nutzen können. Wir nutzen diese Cookies weder zu Werbezwecken, noch um von Ihnen ein Besucher- oder Nutzerprofil zu erstellen. Wir verarbeiten durch technisch notwendige Cookies erhobene Daten auf Basis von Art. 6 Abs. 1 lit. f DSGVO (Interessenabwägung), da wir ein Interesse daran haben, die Website funktionstüchtig und sicher zur Verfügung zu stellen. Dies entspricht auch Ihren Interessen, die Seite optimal nutzen zu können. Zudem kann man Sie mit Hilfe dieser Cookies nicht als Person identifizieren. Deshalb stehen Ihre Interessen der Verarbeitung nicht entgegen.', 'Funktionale Cookies speichern von Ihnen gewählte Optionen, wie z. B. die Region, von der aus Sie die Website besuchen. Dadurch können wir Ihnen die Website auf Ihre Bedürfnisse angepasst zur Verfügung stellen und Ihren Besuch möglichst angenehm gestalten. Die Daten, die dieser Typ Cookie erhebt, sind grundsätzlich anonymisiert und lassen keine Rückschlüsse auf Ihre Aktivitäten auf anderen Websites zu. Wir verarbeiten durch funktionale Cookies erhobene Daten auf Basis von Art. 6 Abs.1 lit. f DSGVO (Interessenabwägung), da wir ein Interesse daran haben, die Website für Sie optimal zur Verfügung zu stellen. Dies entspricht auch Ihren Interessen, die Seite bestmöglich nutzen zu können. Zudem kann man Sie mit Hilfe dieser Cookies nicht als Person identifizieren. Deshalb stehen Ihre Interessen der Verarbeitung nicht entgegen.'],
    options: {
      disabled: true
    }
  }, {
    id: CookieCategories.PERFORMANCE,
    headline: 'Performance-Cookies',
    checkbox: 'Performance-Cookies',
    paragraphs: ['Performance-Cookies erheben Daten über das Nutzungsverhalten der Websitebesucher auf der Website, z. B. welche Unterseiten häufig aufgerufen werden oder Fehlermeldungen auftreten. Die Interhyp AG erhebt und speichert diese Daten, um die Funktion der Website stetig zu verbessern. Wir verarbeiten durch Performance-Cookies erhobene Daten auf Basis Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO).']
  }, {
    id: CookieCategories.PERSONALIZATION,
    headline: 'Personalisierungs-Cookies',
    checkbox: 'Personalisierungs-Cookies',
    paragraphs: ['Personalisierungs-Cookies erheben Daten über Ihre Besuchsgewohnheiten auf der Website und näherungsweise Ihren aktuellen Standort. Wir nutzen diese Daten, um Ihnen für Sie interessante und relevante Werbung anbieten zu können oder auch um Ihnen standortbasierte Dienste anbieten zu können. Die so erhobenen Daten nutzen wir außerdem, um die Häufigkeit, mit der Sie eine Anzeige sehen, zu beschränken. Diese Cookies „merken“ sich Ihre Besuche der Website. Gegebenenfalls teilen wir die durch diese Cookies gewonnenen Informationen mit anderen Unternehmen, wie z. B. Werbeagenturen. Wir verarbeiten durch Personalisierungs-Cookies erhobene Daten auf Basis Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO).']
  }],
  footer: {
    imprint: 'Impressum',
    edit_settings: 'Einstellungen',
    edit_settings_close: 'Einstellungen schließen',
    accept_all: 'Alle akzeptieren',
    reject_all: 'Ablehnen',
    save_settings: 'Einstellungen speichern'
  }
};

var styles$8 = {"Modal":"Modal_W6r5GXVSYF","Header":"Header_KZf1S60nVU","title":"title_YEkqna4GKG","titleNoMargins":"titleNoMargins_vGhVuK1QeH","show":"show_UjY45OKbiP","hide":"hide_BNnYBq6NaQ"};

const CONSENT_MANAGER_SLICE_NAME = 'consentManager';

const consentManagerSlice = createSlice({
  name: CONSENT_MANAGER_SLICE_NAME,
  initialState: CONSENT_MANAGER_INITIAL_SLICE_STATE,
  reducers: {
    rehydrate: (state, {
      payload
    }) => {
      return {
        ...state,
        ...payload
      };
    },
    setConsentManagerOpen: (state, {
      payload
    }) => {
      state.modalOpen = payload;
    },
    setCookieSelection: (state, {
      payload: {
        consent,
        selection,
        initiator
      }
    }) => {
      state.selection = {
        ...state.selection,
        ...selection
      };
      state.consent = consent;
      state.initiator = initiator;
    }
  }
});
const consentManagerReducer = consentManagerSlice.reducer;

const {
  setConsentManagerOpen,
  setCookieSelection,
  rehydrate
} = consentManagerSlice.actions;

const useAppDispatch = useDispatch;

var styles$7 = {"Backdrop":"Backdrop_J15DpkMzZA"};

const Backdrop = ({
  open,
  onClick
}) => {
  return /*#__PURE__*/jsx(Fragment, {
    children: open && /*#__PURE__*/jsx("div", {
      onClick: onClick,
      role: "none",
      className: styles$7.Backdrop
    })
  });
};

var styles$6 = {"CloseButtonIconSize":"21","CloseButtonContainer":"CloseButtonContainer_kPZIK2B2NZ","CloseButton":"CloseButton_LPGLnSYNnn"};

const CloseButton = ({
  onClose
}) => {
  return /*#__PURE__*/jsx("div", {
    className: clsx(styles$6.CloseButtonContainer),
    children: /*#__PURE__*/jsx("button", {
      type: "button",
      onClick: onClose,
      className: styles$6.CloseButton,
      children: /*#__PURE__*/jsx(Icon, {
        size: Number(styles$6.CloseButtonIconSize) || 21,
        icon: closeLight
      })
    })
  });
};

const MODAL_CONTENT_ID = 'modal-content-id';
const noscroll = enable => {
  if (typeof document !== 'undefined') {
    const body = document.documentElement;
    if (enable) {
      // scroll to top
      body.scrollTop = 0;
      // hide scroll bars
      body.style.setProperty('position', 'fixed');
      body.style.setProperty('overflow-y', 'scroll');
      body.style.setProperty('width', '100%');
    } else {
      // show scroll bars
      body.style.removeProperty('position');
      body.style.removeProperty('overflow-y');
      body.style.removeProperty('width');
    }
  }
};
const ModalRoot = ({
  children,
  open,
  title,
  closeable,
  onClose,
  className
}) => {
  return /*#__PURE__*/jsx(Fragment, {
    children: open && /*#__PURE__*/jsx(FocusTrap, {
      active: open,
      focusTrapOptions: {
        initialFocus: false,
        fallbackFocus: `#${MODAL_CONTENT_ID}`
      },
      children: /*#__PURE__*/jsxs("article", {
        id: MODAL_CONTENT_ID,
        className: clsx(styles$8.Modal, className),
        tabIndex: -1,
        children: [/*#__PURE__*/jsxs("header", {
          className: styles$8.Header,
          children: [closeable && /*#__PURE__*/jsx(CloseButton, {
            onClose: onClose
          }), title && /*#__PURE__*/jsx("span", {
            className: classnames(styles$8.title, !closeable && styles$8.titleNoMargins),
            children: title
          })]
        }), children]
      })
    })
  });
};
const Modal = ({
  children,
  containerClassName,
  open,
  ...props
}) => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    noscroll(open);
    const handleKeyDown = event => {
      if (event.key === 'Escape') {
        dispatch(setConsentManagerOpen(false));
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      noscroll(false);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [open, dispatch]);
  return /*#__PURE__*/jsxs("div", {
    className: clsx(containerClassName, open ? styles$8.show : styles$8.hide),
    children: [/*#__PURE__*/jsx(Backdrop, {
      open: open
    }), /*#__PURE__*/jsx(ModalRoot, {
      open: open,
      ...props,
      children: children
    })]
  });
};

var styles$5 = {"content":"content_wdQFAD5WPm"};

const ModalContent = ({
  children,
  className
}) => {
  return /*#__PURE__*/jsx("div", {
    className: clsx(styles$5.content, className),
    children: children
  });
};

const toRawCookieSelection = selection => ({
  [CookieCategories.NECESSARY]: selection[CookieCategories.NECESSARY] ? '1' : '0',
  [CookieCategories.PERSONALIZATION]: selection[CookieCategories.PERSONALIZATION] ? '1' : '0',
  [CookieCategories.PERFORMANCE]: selection[CookieCategories.PERFORMANCE] ? '1' : '0'
});

const getIsConsentGiven = tealium => tealium?.gdpr?.getCookieValues?.()?.consent === 'true';

/**
 * Returns a promise that resolves once tealium is defined and usable in the DOM.
 * @returns {Promise}
 */
const loadTealium = (maxRetries = 20) => {
  let retryTimeout;
  let retryCount = 0;
  const cleanup = () => clearTimeout(retryTimeout);
  return {
    promise: new Promise((resolve, reject) => {
      const retry = () => {
        cleanup();
        if (window.utag?.gdpr) {
          resolve(window.utag);
        } else if (retryCount < maxRetries) {
          retryCount++;
          retryTimeout = setTimeout(retry, Math.max(1000, retryCount * 100));
        } else {
          reject(new Error('Tealium is missing'));
        }
      };
      retry();
      window.addEventListener('tealium::loaded', () => {
        retry();
      }, {
        once: true
      });
    }),
    cleanup
  };
};
const saveTealium = (tealium, selection) => new Promise((resolve, reject) => {
  try {
    tealium.gdpr.setPreferencesValues(toRawCookieSelection(selection));
    tealium.view(window[tealium.udoname || 'utag_data']);
    resolve();
  } catch (error) {
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    const failure = `Tealium is missing: ${error}`;
    // eslint-disable-next-line no-console
    console.error(failure);
    reject(failure);
  }
});

const useTealium = () => {
  const [tealium, setTealium] = useState();
  const [error, setError] = useState(false);
  const ready = useMemo(() => !!tealium, [tealium]);
  useEffect(() => {
    const {
      promise,
      cleanup
    } = loadTealium();
    void (async () => {
      try {
        setTealium(await promise);
      } catch {
        setError(true);
      }
    })();
    return cleanup;
  }, []);
  return useMemo(() => ({
    tealium,
    ready,
    error
  }), [error, ready, tealium]);
};

const defaultTealiumContextValue = {
  tealium: undefined,
  ready: false,
  error: false
};
const TealiumContext = /*#__PURE__*/createContext(defaultTealiumContextValue);
const TealiumProvider = ({
  children
}) => {
  return /*#__PURE__*/jsx(TealiumContext.Provider, {
    value: useTealium(),
    children: children
  });
};

const ConsentManagerOpen$ = new Subject();

let CookieSelectionInitiator = /*#__PURE__*/function (CookieSelectionInitiator) {
  CookieSelectionInitiator["Accept"] = "Accept";
  CookieSelectionInitiator["Reject"] = "Reject";
  CookieSelectionInitiator["Custom"] = "Custom";
  return CookieSelectionInitiator;
}({});

const useCookieValues = tealium => {
  return useMemo(() => {
    return parseCookieValues(tealium?.gdpr?.getCookieValues());
  }, [tealium]);
};

const useSubscribeValue = (obs$, defaultValue) => {
  const [value, setValue] = useState(defaultValue);
  useSubscribe(obs$, setValue);
  return value;
};
const createUseSubscribeValue = obs$ => () => useSubscribeValue(obs$);
const useSubscribe = (obs$, callback) => {
  useEffect(() => {
    const sub = obs$.subscribe(callback);
    return () => {
      sub.unsubscribe();
    };
  }, [callback, obs$]);
};
const createUseSubscribe = obs$ => callback => useSubscribe(obs$, callback);

const selectRootState = state => state;

const selectConsentManagerSliceState = createSelector(selectRootState, state => {
  return state.consentManager;
});

const selectConsentManagerHidden = createSelector(selectConsentManagerSliceState, state => {
  return state.hidden;
});

const selectConsentManagerOpen = createSelector(selectConsentManagerSliceState, state => {
  return state.modalOpen;
});

const selectCookieSelection = createSelector(selectConsentManagerSliceState, state => {
  return state.selection;
});

const getSSRConsentManager = () => {
  return typeof window !== 'undefined' && window.__SSR_CONSENT_MANAGER__;
};

const getSSRConsentManagerState = () => {
  // If running in ssr render the consent manager.
  if (typeof window === 'undefined') {
    return undefined;
  }
  const value = getSSRConsentManager();

  // If no precalculated state (SSR) is present, then hide the
  // consent manager and evaluate it on runtime.
  if (value === undefined || !value) {
    return undefined;
  }
  const {
    consent,
    selection,
    hidden
  } = value;

  // If consent is given, hide the consent manager initially.
  return {
    modalOpen: !hidden && !consent,
    consent,
    selection,
    hidden: hidden ?? false
  };
};

const mergeCookieSelection = (prev, next) => [CookieCategories.PERFORMANCE, CookieCategories.PERSONALIZATION].reduce((prev, category) => ({
  ...prev,
  [category]: next?.[category] ?? prev[category]
}), prev);

const ConsentContext = /*#__PURE__*/createContext(undefined);
const ConsentProvider = ({
  children
}) => {
  const dispatch = useAppDispatch();
  const {
    tealium
  } = useContext(TealiumContext);
  // Previous cookie selection received by tealium.
  const recovered = useCookieValues(tealium);
  // The saved cookie selection of the user.
  const hydrated = useMemo(() => getSSRConsentManagerState(), []);
  const selection = useSelector(selectCookieSelection);
  const modalOpen = useSelector(selectConsentManagerOpen);
  const hidden = useSelector(selectConsentManagerHidden);
  useEffect(() => {
    if (hydrated) {
      dispatch(rehydrate(hydrated));
    }
  }, [dispatch, hydrated]);
  useSubscribe(ConsentManagerOpen$.pipe(distinctUntilChanged()), shouldOpen => {
    dispatch(setConsentManagerOpen(shouldOpen));
  });

  /**
   *  The user has made a selection but tealium was not ready.
   */
  const deferredSave = useRef();
  const saveSelection = useCallback((tealium, update) => {
    if (!update?.selection) {
      return [false]; // Nothing to save.
    }

    // Optimistically close the modal.
    dispatch(setConsentManagerOpen(false));

    // Dispatch the selection to the context state.
    dispatch(setCookieSelection({
      consent: true,
      ...update
    }));

    // If Tealium is not read, then save the selection for later
    // when Tealium is loaded ...
    if (tealium === undefined) {
      deferredSave.current = update;
      return [false];
    }

    // ... otherwise pass the selection down to tealium.
    return [true, saveTealium(tealium, update.selection)];
  }, [dispatch]);

  // When tealium is loaded
  // - try to save a deferred selection
  // - otherwise determine if the modal should be shown.
  useEffect(() => {
    if (tealium) {
      const [saved] = saveSelection(tealium, deferredSave.current);
      if (!saved) {
        // Determine the modal state:
        // - if the modal was not marked as hidden
        // - if consent was not given
        if (!hidden) {
          dispatch(setConsentManagerOpen(!getIsConsentGiven(tealium)));
        }
        // Try to remove the initial ssr styling.
        if (typeof document !== 'undefined') {
          document.querySelector('#SSRConsentManager_Style')?.remove();
        }
      }
    }
  }, [dispatch, hidden, saveSelection, tealium]);

  // Check if a cookie preselection exists.
  useEffect(() => {
    if (recovered && !deferredSave.current) {
      const {
        consent,
        selection
      } = recovered;
      dispatch(setCookieSelection({
        consent,
        selection: mergeCookieSelection(initSelection, selection),
        initiator: undefined
      }));
    }
  }, [dispatch, recovered]);
  const saveCustom = useCallback(async selection => {
    const [, promise] = saveSelection(tealium, {
      selection,
      initiator: CookieSelectionInitiator.Custom
    });
    await promise;
  }, [saveSelection, tealium]);
  const saveAcceptAll = useCallback(async () => {
    const [, promise] = saveSelection(tealium, {
      selection: fullSelection,
      initiator: CookieSelectionInitiator.Accept
    });
    await promise;
  }, [saveSelection, tealium]);
  const saveRejectAll = useCallback(async () => {
    const [, promise] = saveSelection(tealium, {
      selection: initSelection,
      initiator: CookieSelectionInitiator.Reject
    });
    await promise;
  }, [saveSelection, tealium]);
  return /*#__PURE__*/jsx(ConsentContext.Provider, {
    value: useMemo(() => ({
      modalOpen,
      selection,
      saveCustom,
      saveAcceptAll,
      saveRejectAll
    }), [modalOpen, saveAcceptAll, saveCustom, saveRejectAll, selection]),
    children: children
  });
};

const CustomCookieSelectionContext = /*#__PURE__*/createContext(undefined);
const CustomCookieSelectionProvider = ({
  children
}) => {
  const {
    selection
  } = useContext(ConsentContext);
  const methods = useForm({
    defaultValues: selection
  });
  const {
    watch,
    setValue
  } = methods;

  // Update the current user cookie selection if the saved selection of the
  // ConsentContext has updated.
  useEffect(() => {
    Object.entries(selection).forEach(([k, v]) => {
      setValue(k, v);
    });
  }, [selection, setValue]);

  /**
   * Returns the current user cookie selection.
   */
  const getCustomCookieValues = useCallback(() => watch(), [watch]);
  return /*#__PURE__*/jsx(CustomCookieSelectionContext.Provider, {
    value: useMemo(() => ({
      getCustomCookieValues
    }), [getCustomCookieValues]),
    children: /*#__PURE__*/jsx(FormProvider, {
      ...methods,
      children: children
    })
  });
};

const reducer = {
  [CONSENT_MANAGER_SLICE_NAME]: consentManagerReducer
};

const ConsentManagerOpenChangedSink$ = new Subject();
const ConsentManagerOpenChanged$ = ConsentManagerOpenChangedSink$.asObservable();

const CookieSelectionAppliedSink$ = new BehaviorSubject({
  initiator: undefined,
  selection: initSelection
});
const CookieSelectionApplied$ = CookieSelectionAppliedSink$.asObservable();

const selectCookieInitiator = createSelector(selectConsentManagerSliceState, state => {
  return state.initiator;
});

// Create the middleware instance and methods
const listener = createListenerMiddleware();
listener.startListening({
  actionCreator: setCookieSelection,
  effect: (action, {
    getState
  }) => {
    window.dispatchEvent(new Event('gdprCookieChanged', {
      composed: true,
      cancelable: false,
      bubbles: true
    }));
    CookieSelectionAppliedSink$.next({
      selection: selectCookieSelection(getState()),
      initiator: selectCookieInitiator(getState())
    });
  }
});
listener.startListening({
  actionCreator: setConsentManagerOpen,
  effect: (action, {
    getState
  }) => {
    ConsentManagerOpenChangedSink$.next(selectConsentManagerOpen(getState()));
  }
});
const {
  middleware
} = listener;

const middlewares = [middleware];

const createStore = preloadedState => configureStore({
  reducer,
  middleware: getDefaultMiddleware => getDefaultMiddleware().prepend(middlewares),
  preloadedState
});

var styles$4 = {"Checkbox":"Checkbox_AQbZDq5o0G","Paragraph":"Paragraph_5XKlnCntny"};

const CustomCookieSelection = () => {
  const {
    control
  } = useFormContext();
  return /*#__PURE__*/jsx("form", {
    onSubmit: e => e.preventDefault(),
    children: useMemo(() => Content.settings.map(({
      id,
      headline,
      checkbox,
      paragraphs,
      options: {
        disabled = false
      } = {}
    }) => /*#__PURE__*/jsx(Controller, {
      control: control,
      name: id,
      render: ({
        field: {
          ref,
          value,
          ...field
        }
      }) => /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx(Typography, {
          variant: "h3",
          children: headline
        }), /*#__PURE__*/jsx(Checkbox, {
          id: id,
          classNames: styles$4.Checkbox,
          inputRef: ref,
          checked: value,
          disabled: disabled,
          ...field,
          children: checkbox
        }), paragraphs.map((paragraph, i) =>
        /*#__PURE__*/
        // eslint-disable-next-line react/no-array-index-key
        jsx(Typography, {
          className: styles$4.Paragraph,
          margin: false,
          children: paragraph
        }, i))]
      })
    }, id)), [control])
  });
};

var styles$3 = {"intro":"intro_9tLSQoWb7Q","text":"text_g-XJFA96hg"};

const Introduction = ({
  privacyLink,
  privacyCookieLink,
  closeable
}) => {
  return /*#__PURE__*/jsxs("div", {
    className: classnames(closeable && styles$3.intro),
    children: [/*#__PURE__*/jsxs(Typography, {
      margin: false,
      className: classnames(closeable && styles$3.text),
      children: [Content.introduction.paragraph_1, ' ', /*#__PURE__*/jsx(Link, {
        href: privacyLink,
        inline: true,
        children: Content.introduction.privacy_link
      }), "."]
    }), closeable && /*#__PURE__*/jsxs(Typography, {
      margin: false,
      variant: "strong",
      children: [Content.introduction.legal, ' ', /*#__PURE__*/jsx(Link, {
        href: privacyCookieLink,
        inline: true,
        children: Content.introduction.legal_link
      }), "."]
    })]
  });
};

var styles$2 = {"ModalFooter":"ModalFooter_J4RH5ZVSpo","editable":"editable_f69KNjZKsl","accept":"accept_k80IBk6qPq","reject":"reject_GGJnCGKXJS","custom":"custom_tONuQ4v5kM","footnote":"footnote_8-mIbwQ91G"};

var styles$1 = {"Footer":"Footer_M8CA45-3jX"};

const ModalFooter = ({
  children,
  className
}) => {
  return /*#__PURE__*/jsx("div", {
    className: clsx(styles$1.Footer, className),
    children: children
  });
};

var styles = {"button":"button_nDJy3Yr1AE"};

const InlineButton = ({
  onClick,
  className,
  children
}) => {
  return /*#__PURE__*/jsx("button", {
    type: "button",
    className: clsx(styles.button, className),
    onClick: onClick,
    children: children
  });
};

const EditCookieSelectionButton = ({
  onClick,
  className
}) => {
  return /*#__PURE__*/jsx(InlineButton, {
    onClick: onClick,
    className: className,
    children: Content.footer.edit_settings
  });
};
const CloseEditCookieSelectionButton = ({
  onClick,
  className
}) => {
  return /*#__PURE__*/jsx(InlineButton, {
    onClick: onClick,
    className: className,
    children: Content.footer.edit_settings_close
  });
};
const SaveCookieSelectionButton = ({
  onClick,
  className
}) => {
  return /*#__PURE__*/jsx(Button, {
    id: "cm-btnAcceptCustom",
    variant: "outlined",
    onClick: onClick,
    className: className,
    children: Content.footer.save_settings
  });
};
const AcceptAllButton = ({
  onClick,
  className
}) => {
  return /*#__PURE__*/jsx(Button, {
    id: "cm-btnAcceptAll",
    onClick: onClick,
    className: className,
    children: Content.footer.accept_all
  });
};
const RejectAllButton = ({
  onClick,
  className
}) => {
  return /*#__PURE__*/jsx(Button, {
    id: "cm-btnRejectAll",
    onClick: onClick,
    className: className,
    variant: "outlined",
    children: Content.footer.reject_all
  });
};

const ModalFooterActions = ({
  editCustomCookieSelection,
  onEditCustomCookieSelection,
  onCloseEditCustomCookieSelection,
  saveAcceptAll,
  saveRejectAll,
  saveCustom,
  imprintLink
}) => {
  const [rerender, setRerender] = useState();
  useIsomorphicLayoutEffect(() => {
    // The initial rendering state must be forcibly updated because the rehydration does not match
    // the AB test state set after the SSG build.
    setRerender(Math.random());
  }, []);
  return /*#__PURE__*/jsxs(ModalFooter, {
    className: clsx(styles$2.ModalFooter, editCustomCookieSelection && styles$2.editable),
    children: [/*#__PURE__*/jsxs("div", {
      className: styles$2.footnote,
      children: [editCustomCookieSelection ? /*#__PURE__*/jsx(CloseEditCookieSelectionButton, {
        onClick: onCloseEditCustomCookieSelection,
        className: styles$2.custom
      }) : /*#__PURE__*/jsx(EditCookieSelectionButton, {
        onClick: onEditCustomCookieSelection,
        className: styles$2.custom
      }), /*#__PURE__*/jsx(Link, {
        inline: true,
        href: imprintLink,
        className: styles$2.imprint,
        children: Content.footer.imprint
      })]
    }), editCustomCookieSelection ? /*#__PURE__*/jsx(SaveCookieSelectionButton, {
      onClick: saveCustom,
      className: styles$2.custom
    }) : /*#__PURE__*/jsx(RejectAllButton, {
      onClick: saveRejectAll,
      className: styles$2.reject
    }), /*#__PURE__*/jsx(AcceptAllButton, {
      onClick: saveAcceptAll,
      className: styles$2.accept
    })]
  }, rerender);
};

const ConsentLayerRoot = ({
  privacyLink,
  privacyCookieLink,
  imprintLink
}) => {
  const [editCustomCookieSelection, setEditCustomCookieSelection] = useState(false);
  const {
    modalOpen,
    saveAcceptAll,
    saveRejectAll,
    saveCustom
  } = useContext(ConsentContext);
  const {
    getCustomCookieValues
  } = useContext(CustomCookieSelectionContext);
  const introductionRef = useRef(null);
  const saveCustomCookies = useCallback(() => {
    saveCustom(getCustomCookieValues());
  }, [getCustomCookieValues, saveCustom]);
  const closeCookieSelection = () => {
    setEditCustomCookieSelection(false);
  };
  return /*#__PURE__*/jsxs(Modal, {
    open: modalOpen,
    title: editCustomCookieSelection ? Content.header.settings : Content.header.headline,
    closeable: editCustomCookieSelection,
    onClose: closeCookieSelection,
    className: clsx(styles$9.Modal, !editCustomCookieSelection && styles$9.ModalWithTopMargin),
    containerClassName: MODAL_CONTAINER_CLASS_NAME,
    children: [/*#__PURE__*/jsx(ModalContent, {
      className: styles$9.ModalContent,
      children: /*#__PURE__*/jsxs("div", {
        className: styles$9.ScrollView,
        ref: introductionRef,
        children: [/*#__PURE__*/jsx(Introduction, {
          closeable: editCustomCookieSelection,
          privacyLink: privacyLink,
          privacyCookieLink: privacyCookieLink
        }), editCustomCookieSelection && /*#__PURE__*/jsx(CustomCookieSelection, {})]
      })
    }), /*#__PURE__*/jsx(ModalFooterActions, {
      editCustomCookieSelection: editCustomCookieSelection,
      onCloseEditCustomCookieSelection: closeCookieSelection,
      onEditCustomCookieSelection: () => {
        setEditCustomCookieSelection(true);
        introductionRef.current?.scrollIntoView();
      },
      saveRejectAll: saveRejectAll,
      saveAcceptAll: saveAcceptAll,
      saveCustom: saveCustomCookies,
      imprintLink: imprintLink
    })]
  });
};
const ConsentManager = ({
  privacyLink,
  privacyCookieLink,
  imprintLink,
  preloadedState
}) => {
  const store = useMemo(() => createStore(preloadedState), [preloadedState]);
  return /*#__PURE__*/jsx(Provider, {
    store: store,
    children: /*#__PURE__*/jsx(ConsentManagerWithoutStore, {
      privacyLink: privacyLink,
      privacyCookieLink: privacyCookieLink,
      imprintLink: imprintLink
    })
  });
};
const ConsentManagerWithoutStore = ({
  privacyLink,
  privacyCookieLink,
  imprintLink
}) => {
  return /*#__PURE__*/jsx(TealiumProvider, {
    children: /*#__PURE__*/jsx(ConsentProvider, {
      children: /*#__PURE__*/jsx(CustomCookieSelectionProvider, {
        children: /*#__PURE__*/jsx(ConsentLayerRoot, {
          privacyLink: privacyLink,
          privacyCookieLink: privacyCookieLink,
          imprintLink: imprintLink
        })
      })
    })
  });
};

const mockUseSubscribeValue = module => {
  const actual = module.useSubscribeValue;
  const map = new Map();
  jest.spyOn(module, 'useSubscribeValue').mockImplementation((obs$, defaultValue) => {
    const result = map.get(obs$);
    if (result) {
      return result();
    }
    return actual(obs$, defaultValue);
  });
  const on = obs$ => {
    let mock = map.get(obs$);
    if (!mock) {
      map.set(obs$, mock = jest.fn());
    }
    return mock;
  };
  return {
    on
  };
};

const CookieSelectionChanged$ = CookieSelectionApplied$.pipe(map(({
  selection
}) => selection));

export { ConsentManager, ConsentManagerOpen$, ConsentManagerOpenChanged$, ConsentManagerWithoutStore, CookieSelectionApplied$, CookieSelectionChanged$, createUseSubscribe, createUseSubscribeValue, getSSRConsentManager, mockUseSubscribeValue, useSubscribe, useSubscribeValue };
//# sourceMappingURL=index.js.map
